import { render, staticRenderFns } from "./Querymenubar.vue?vue&type=template&id=63a08ccc&scoped=true"
import script from "./Querymenubar.vue?vue&type=script&lang=js"
export * from "./Querymenubar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a08ccc",
  null
  
)

export default component.exports